import { CustomSectionState } from 'api/custom-section/types';
import { FC } from 'react';
import { TextBlockSectionComponentProps } from '../types';
import { TextBlockSectionPromptInput } from './prompt-input';
import { TextBlockSectionPromptPreview } from './prompt-preview';

export const TextBlockSectionPrompt: FC<TextBlockSectionComponentProps> = (
  props,
) => {
  const isEditing = props.node.attrs.state === CustomSectionState.Open;

  const handleEditDone = () => {
    props.updateAttributes({ state: CustomSectionState.Closed });
  };

  const handleWrapperClick = () => {
    props.onOpen();
  };

  return (
    <div>
      {isEditing ? (
        <TextBlockSectionPromptInput
          {...props}
          onEditDone={handleEditDone}
          pageType={props.pageType}
        />
      ) : (
        <TextBlockSectionPromptPreview
          {...props}
          onWrapperClick={handleWrapperClick}
        />
      )}
    </div>
  );
};
